import {
  createRouter,
  createWebHistory,
  RouteRecordRaw,
  Router,
} from "vue-router";
import NotFoundView from "@/views/NotFoundView.vue";
import LoginView from "@/views/LoginView.vue";
import OverallView from "@/views/OverallView.vue";
import ResetPasswordView from "@/views/ResetPasswordView.vue";
import ResetPasswordView1 from "@/views/ResetPasswordView1.vue";
import ContainerView from "@/views/ContainerView.vue";
import CreateUpgradePlanView from "@/views/upgrade/CreateUpgradePlanView.vue";
import UpgradeListView from "@/views/upgrade/UpgradeListView.vue";
import OrganizationListView from "@/views/organization/OrganizationListView.vue";
import OrganizationInfoView from "@/views/organization/OrganizationInfoView.vue";
import ShipListView from "@/views/product/ShipListView.vue";
import UserInfoView from "@/views/user/UserInfoView.vue";
import ContentErrorView from "@/views/ContentErrorView.vue";
import ShipInfoView from "@/views/product/ShipInfoView.vue";
import GenerateEndpointConnectorView from "@/views/control/GenerateEndpointConnectorView.vue";
import ShipProtocolTemplateView from "@/views/ship/ShipProtocolTemplateView.vue";
import CcsReportView from "@/views/ccs/CcsReportView.vue";
import CertBatchManagementView from "@/views/cert/CertBatchManagementView.vue";
import ProtocolFileView from "@/views/device/ProtocolFileView.vue";
import ShipCalcParamView from "@/views/ship/ShipCalcParamView.vue";
import ExchangeRateView from "@/views/system/ExchangeRateView.vue";
import ArchiveManagementView from "@/views/system/ArchiveManagementView.vue";
import PersonalInformationView from "@/views/system/PersonalInformationView.vue";
import ManagerAccountView from "@/views/system/ManagerAccountView.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/login",
    name: "login",
    component: LoginView,
    meta: { requiresAuth: false },
    alias: "/",
  },
  {
    path: "/reset_password",
    name: "resetPassword",
    component: ResetPasswordView,
    meta: { requiresAuth: false },
  },
  {
    path: "/resetPassword",
    name: "resetPassword1",
    component: ResetPasswordView1,
    meta: { requiresAuth: false },
    props: true,
  },
  {
    path: "/platform",
    name: "platform",
    component: ContainerView,
    children: [
      {
        path: "/overall",
        name: "overall",
        component: OverallView,
      },
      {
        path: "/create_upgrade_plan",
        name: "createUpgradePlan",
        component: CreateUpgradePlanView,
      },
      {
        path: "/upgrade_list",
        name: "upgradeList",
        component: UpgradeListView,
      },
      {
        path: "/organization_list",
        name: "organizationList",
        component: OrganizationListView,
      },
      {
        path: "/organization_info",
        name: "organizationInfo",
        component: OrganizationInfoView,
        props: true,
      },
      {
        path: "/ship_list",
        name: "shipList",
        component: ShipListView,
      },
      {
        path: "/generate_endpoint_connector",
        name: "generateEndpointConnector",
        component: GenerateEndpointConnectorView,
      },
      {
        path: "/user_info",
        name: "userInfo",
        component: UserInfoView,
        props: true,
      },
      {
        path: "/ship_info",
        name: "shipInfo",
        component: ShipInfoView,
        props: true,
      },
      {
        path: "/content_error",
        name: "contentError",
        component: ContentErrorView,
      },
      {
        path: "/ship_protocol_template",
        name: "shipProtocolTemplate",
        component: ShipProtocolTemplateView,
      },
      {
        path: "/ccs_report",
        name: "ccsReport",
        component: CcsReportView,
      },
      {
        path: "/cert_batch_management",
        name: "certBatchManagement",
        component: CertBatchManagementView,
      },
      {
        path: "/protocol_file",
        name: "protocolFile",
        component: ProtocolFileView,
      },
      {
        path: "/ship_list/ship_calc_param",
        name: "shipCalcParam",
        component: ShipCalcParamView,
      },
      {
        path: "/exchange_rate",
        name: "exchangeRate",
        component: ExchangeRateView,
      },
      {
        path: "/archive_management",
        name: "archiveManagement",
        component: ArchiveManagementView,
      },
      {
        path: "/personal_information",
        name: "personal_information",
        component: PersonalInformationView,
      },
      {
        path: "/manager_account",
        name: "managerAccount",
        component: ManagerAccountView,
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*", // 捕获所有未匹配的路由
    name: "not_found",
    component: NotFoundView, // 更新部分
  },
];

const router: Router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

// 添加全局导航守卫以处理错误
router.onError((error) => {
  console.error(error);
  // 可以根据需要添加自定义处理逻辑
});

export default router;
